import * as activityLogger from "../helpers/activity-logger";
import { getDeviceType } from './deviceUtils';

let scrollToTopBtn = document.getElementById('scrollToTopBtn');

window.onscroll = function() {
    scrollFunction();
};

function scrollFunction() {
    if(document.body.scrollTop > 40 || document.documentElement.scrollTop > 40){
        scrollToTopBtn.classList.replace('hide_btn', 'show_btn');
    } else {
        scrollToTopBtn.classList.replace('show_btn', 'hide_btn');
    }
}

function scrollToTop() {
    const deviceType = getDeviceType();
    activityLogger.logActivity('Scroll to top btn', $("body").data("route"), ["clicked", `source: ${deviceType}`]);
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
}

if(scrollToTopBtn !== null){
    scrollToTopBtn.addEventListener('click', scrollToTop);
}